export function capitalizeFirst(input: string, locale?: string) {
  if (!input) return '';
  const lower = locale ? input.toLocaleLowerCase(locale) : input.toLowerCase();
  return lower.charAt(0).toLocaleUpperCase(locale) + lower.slice(1);
}
